// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./src/css/video.css
 ** module id = 7
 ** module chunks = 0 1
 **/